import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { GroupServices } from '@/services/apis';
import { getCookie } from '@/utils';



const initialState = {
  groups: [],
  loading: true,
  error: false,
  errorMessage: '',
  totcount: 0
};

export const fetchAllGroup = createAsyncThunk('groups/fetchAllGroup', async ({ pagination, groupName, domainName }: any) => {
  const response = await GroupServices.fetchAllGroups(pagination.page + 1, pagination.rowsPerPage, groupName, domainName);
  return response;
});

export const createGroup = createAsyncThunk('group/createNewGroup', async (groupData: any, domainName: any) => {
  const response = await GroupServices.createGroup(groupData, domainName);
  return response;
});

export const deleteGroup = createAsyncThunk('group/deleteGroup', async (groupId?: any) => {
  const domainName = getCookie('xsm_user_domain');
  const response = await GroupServices.deleteGroup(groupId, domainName);
  return response;
});

export const updateGroup = createAsyncThunk('group/updateGroup', async (groupData: any) => {
  const { groupId, ...finalData } = groupData;
  const data = await GroupServices.updateGroup(finalData, groupId);
  return data;
});

export const deleteUsergp = createAsyncThunk('group/deleteUsergp', async (groupId: any) => {
  try {
    const response = await GroupServices.deleteUsergp(groupId);
    return response;
  } catch (err) {
    console.log(err);
  }
});

export const downloadGroup = createAsyncThunk('group/downloadGroup', async () => {
  const response = await GroupServices.downloadGroup();
  return response;
});

export const downloadCsv = createAsyncThunk('group/downloadCsv', async () => {
  const response = await GroupServices.downloadCsv();
  return response;
});

export const uploadGroups = createAsyncThunk(
  'group/uploadGroups',
  async ({ dom_name, data, created_by, modified_by, status }: any) => {
    const response = await GroupServices.uploadCsv({ dom_name, data, created_by, modified_by, status });
    return response;
  }
);

export const GroupSlice = createSlice({
  name: 'group',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchAllGroup.pending, (state) => {});
    builder.addCase(fetchAllGroup.fulfilled, (state, { payload }) => {
      return { ...state, groups: payload?.result || [], loading: false, totcount: payload?.totalRecords };
    });
    builder.addCase(fetchAllGroup.rejected, (state) => {});
  }
});

export const groupSelector = (state: any) => state.group;

export default GroupSlice.reducer;
